import { type JSX,MouseEventHandler } from 'react';

import { Button } from '@mui/material';
import { useTheme } from '@mui/material/styles';

type CreateButtonProps = {
    onClickHandler?: MouseEventHandler<HTMLButtonElement>;
    disabled?: boolean;
    buttonName: string;
};

export function CreateButton({
    onClickHandler,
    disabled,
    buttonName
}: Readonly<CreateButtonProps>): JSX.Element {
    const theme = useTheme();
    const isDark = theme.palette.mode === 'dark';

    return (
        <Button
            sx={{
                fontFamily: ['Source Sans Pro'].join(','),
                WebkitFontSmoothing: 'auto',
                letterSpacing: 'normal',
                textTransform: 'capitalize',
                fontSize: 16,
                ...(isDark && {
                    color: 'primary.accent',
                    borderColor: 'primary.accent',
                    '&:hover': {
                        borderColor: 'primary.accent',
                        backgroundColor: 'primary.ultraLight',
                    },
                }),
            }}
            variant="outlined"
            onClick={onClickHandler}
            disabled={disabled}
        >
            {buttonName}
        </Button>
    );
}
